module.exports = __webpack_public_path__ + "media/chuti-intro.d184c2c2.mp4";